import React from 'react';
import {UncontrolledTooltip} from "reactstrap";

function BulkLocationEditorHealthCare ({locationPatch, singleLocationMode, updateHealthCareManagementPatch}) {

  const toggleAcceptingNewPatients = (acceptingNewPatients) => (event) => {
    const newAcceptingNewPatients = (event.target.checked) ? acceptingNewPatients : undefined;

    updateHealthCareManagementPatch({
      ...locationPatch.listingManagementSpecs.healthCareManagement,
      acceptingNewPatients: (newAcceptingNewPatients === undefined) ? null : newAcceptingNewPatients
    });
  };

  return <div className="card-spacer-top card-spacer-bottom">
    <h5>Healthcare Information</h5>
    <table className="card-spacer-top" style={{"width": "100%"}}>
      <tbody style={{"width": "100%"}}>
      <tr>
        <td style={{"width": "141px"}}>{/* Set width on first column so everything lines up nicely */}
          <label htmlFor="npi" style={{display: "block"}} className={(!singleLocationMode && "cursor-not-allowed")}>
            National Provider Identifier
          </label>
        </td>
        <td>
          <input
            disabled={!singleLocationMode}
            type="text"
            className={"form-control text-input" + (!singleLocationMode ? " cursor-not-allowed" : "")}
            name="npi"
            id="npi"
            value={locationPatch.listingManagementSpecs.healthCareManagement.nationalProviderIdentifier}
            onChange={(e) => updateHealthCareManagementPatch({
                ...locationPatch.listingManagementSpecs.healthCareManagement,
                nationalProviderIdentifier: !e.target.value ? null : e.target.value
            }
            )}
          />
          {!singleLocationMode && <UncontrolledTooltip target="npi">
            National Provider Identifier can only be edited for single locations.
          </UncontrolledTooltip>}
        </td>
      </tr>
      <tr>
        <td/>
        <td>
          <div className="invalid-feedback" style={{"display": "block", opacity: "0"}}>line spacer</div>
        </td>
      </tr>
      <tr>
        <td style={{"width": "141px"}}>{/* Set width on first column so everything lines up nicely */}
          <label htmlFor="specialties" style={{display: "block"}}>
            Specialties
          </label>
        </td>
        <td>
          <input
            type="text"
            className="form-control text-input"
            name="specialties"
            value={locationPatch.listingManagementSpecs.healthCareManagement.specialties}
            onChange={(e) => updateHealthCareManagementPatch({
                ...locationPatch.listingManagementSpecs.healthCareManagement,
                specialties: !e.target.value ? null : e.target.value
            }
            )}
          />
        </td>
      </tr>
      <tr>
        <td/>
        <td>
          <div className="invalid-feedback" style={{"display": "block", opacity: "0"}}>line spacer</div>
        </td>
      </tr>
      <tr>
        <td style={{"width": "180px"}}>{/* Set width on first column so everything lines up nicely */}
          <label htmlFor="conditionsTreated" style={{display: "block"}}>
            Conditions Treated
          </label>
        </td>
        <td>
          <input
            type="text"
            className="form-control text-input"
            name="conditionsTreated"
            value={locationPatch.listingManagementSpecs.healthCareManagement.conditionsTreated}
            onChange={(e) => updateHealthCareManagementPatch({
                ...locationPatch.listingManagementSpecs.healthCareManagement,
                conditionsTreated: !e.target.value ? null : e.target.value
            }
            )}
          />
        </td>
      </tr>
      <tr>
        <td/>
        <td>
          <div className="invalid-feedback" style={{"display": "block", opacity: "0"}}>line spacer</div>
        </td>
      </tr>
      <tr>
        <td style={{"width": "141px"}}>{/* Set width on first column so everything lines up nicely */}
          <label htmlFor="primaryCategory" style={{display: "block"}}>
           Accepting New Patients
          </label>
        </td>
        <td>
          <div className="custom-control custom-checkbox control-spacer-left inline-block">
            <input type="checkbox" id={"acceptingNewPatients-yes"} className="custom-control-input" checked={locationPatch.listingManagementSpecs.healthCareManagement.acceptingNewPatients === true} onChange={toggleAcceptingNewPatients(true)} />
            <label className="custom-control-label" htmlFor={"acceptingNewPatients-yes"}>Yes</label>
          </div>
          <div className="custom-control custom-checkbox control-spacer-left inline-block">
            <input type="checkbox" id={"acceptingNewPatients-no"} className="custom-control-input" checked={locationPatch.listingManagementSpecs.healthCareManagement.acceptingNewPatients === false} onChange={toggleAcceptingNewPatients(false)} />
            <label className="custom-control-label" htmlFor={"acceptingNewPatients-no"}>No</label>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
}

export default BulkLocationEditorHealthCare;